import { useTranslation } from "next-i18next";

import { I18nextLocale } from "@/types/types";
import { getLocaleParts } from "@/utils/localisation-utils.js";

const useLocaleHelper = () => {
  const { i18n } = useTranslation();

  const { lang: currentLanguage, country: currentCountry } = getLocaleParts(
    i18n.language
  );

  return {
    getLocaleParts,
    currentLanguage,
    currentCountry,
    currentLocale: i18n.language as I18nextLocale,
  };
};

export default useLocaleHelper;
